import React, { memo, useMemo, useCallback, useEffect, useState } from 'react';
import { __WEB__ } from '../../../constants/styles';

import { NavBar } from '../../components';

import { SUCCESS } from '../../../actions/statusTypes';
// import { EVENT_TYPE_AIRFORCE_DEPLOYMENT as EVENT_TYPE_READINESS } from '../../../constants/eventTypes';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getAssociatedEmployer,
  getGroupsForEmployer,
  getAssociatedEmployerTimezone,
  getAssociatedEmployerUIConfig,
} from '../../../selectors/employers';
import {
  acceptOrRejectEmployerApptRequest,
  resetStatus as resetEmployerStatus,
} from '../../employer/actions';
import { submitPHARequest, resetStatus, setAppointmentDetails } from './slice';
import { getEditingCase, getEditingCasePatient } from '../../cases/selector';
import { resetState } from '../../cases/actions';

import momentTz from 'moment-timezone';
import moment from 'moment';

import AppointmentRequestForm from './appointment_request_form';

const AppointmentRequestFormScreenLoggedIn = memo((props) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);

  useEffect(
    NavBar.setup(
      props,
      !__WEB__ && {
        buttons: { leftButtons: [NavBar.buttons.done] },
      }
    ),
    []
  );
  useEffect(() => {
    props.actions.resetStatus();
    props.actions.resetEmployerStatus();
  }, []);
  useEffect(
    function () {
      return function () {
        props.actions.resetStatus();
        props.actions.resetEmployerStatus();
        if (!props.retainPatientState) {
          props.actions.resetState();
          props.actions.setAppointmentDetails(null);
        }
        if (submitSuccess) props.callOnUnmount?.();
      };
    },
    [submitSuccess]
  );

  useEffect(() => {
    if (props.aptsRequestStatus === SUCCESS || props.aptsRequestUpdateStatus === SUCCESS) {
      setSubmitSuccess(true);
    }
  }, [props.aptsRequestStatus, props.aptsRequestUpdateStatus]);

  const submit = useCallback(
    (requestObj) => {
      if (!props.employerId) return;
      if (props.request) {
        const employerId = props.request.employer_id;
        const status = true;
        const appointmentRequestId = props.request.appointmentRequestId;
        props.actions.acceptOrRejectEmployerApptRequest(employerId, appointmentRequestId, status);
      } else {
        props.actions.submitPHARequest({ requestObj, employerId: props.employerId });
      }
    },
    [props.request, props.employerId]
  );

  const eventData = useMemo(() => {
    let deets = {
      selectedDate: props.selectedDate,
      selectedTimes: props.selectedTimes,
      eventType: props.eventType,
    };
    let selectedMoment = null;
    if (props.request) {
      selectedMoment = momentTz(props.request.appointment_time).tz(props.timezone);
      deets.eventType = props.request.appointment_type;
    } else if (props.e) {
      selectedMoment = moment(props.e.startDate);
      deets.eventType = props.e.eventTypeName;
    }
    if (selectedMoment) {
      deets.selectedDate = selectedMoment.toDate();
      deets.selectedTimes = [selectedMoment.format('HH:mm')];
    }
    return deets;
  }, [props.request, props.e]);

  const formData = useMemo(() => {
    if (props.request) {
      const request = props.request;
      const details = request?.details;
      const fullName = details?.full_name;
      return {
        firstName: fullName?.split(' ')[0] || null,
        lastName: fullName?.split(' ').slice(1).join(' ') || null,
        email: request?.email,
        phone: details?.phone,
        squadron: details?.squadron || details?.group,
        rank: details?.rank,
        status: details?.patientRole,
        dodId: details?.dod_id,
        serviceBranch: details?.service_branch,
        department: details?.employer_department_id,
        imr: details?.imr,
        appointmentReason: details?.appointmentReason,
        audiogramType: details?.audiogramType,
        updatedAt: request?.updatedAt || request?.createdAt,
        requestedAt: request?.updatedAt || request?.createdAt,
        upcomingApptDate: details?.upcomingApptDate,
      };
    } else if (props.patient) {
      const fullName = props.patient?.fullName;
      return {
        name: fullName,
        firstName: fullName?.split(' ')[0] || null,
        lastName: fullName?.split(' ').slice(1).join(' ') || null,
        email: props.patient?.email,
        phone: props.patient?.phone,
        squadron: props.patientCase?.group,
        rank: props.patient?.rank,
        status: props.patient?.role,
        dodId: props.patient?.dod_id,
        serviceBranch: props.patient?.service_branch,
        department: props.patient?.departmentId,
        imr: props?.e?.extraData?.imr,
        appointmentReason: props?.e?.extraData?.appointmentReason,
        audiogramType: props?.e?.extraData?.audiogramType,
        createdByEmail: props.e?.createdByEmail,
        confirmedAt: props.e?.updated,
        upcomingApptDate: props.e?.extraData?.upcomingApptDate,
      };
    }
    return formData;
  }, [props.request, props.patient]);

  if (!props.employerId) return null;

  return (
    <AppointmentRequestForm
      employerId={props.employerId}
      formData={formData}
      selectedDate={eventData.selectedDate}
      selectedTimes={eventData.selectedTimes}
      eventType={eventData.eventType}
      allDay={props.allDay}
      groups={props.groups}
      departments={props.departments}
      status={props.aptsRequestStatus}
      aptsRequestUpdateStatus={props.aptsRequestUpdateStatus}
      errorMessage={props.aptsRequestUpdateError || props.aptsRequestError}
      submitBtnLabel="Schedule"
      readOnly={props.readOnly}
      readOnlyUnlessMissing={props.readOnlyUnlessMissing}
      hideButtons={props.hideButtons}
      onSubmit={submit}
      eventTypeDefaults={props.eventTypeDefaults}
      schedules={props.schedules}
      admin={props.admin}
      patient={props.patient}
      timezone={props.timezone}
      readOnlyData={formData}
    />
  );
});

function mapStateToProps(state, ownProps) {
  const employer = getAssociatedEmployer(state);

  return {
    employerId: employer?.employerId,
    timezone: getAssociatedEmployerTimezone(state),
    patientCase: getEditingCase(state),
    patient: getEditingCasePatient(state),
    groups: getGroupsForEmployer(state),
    departments: employer?.departments,
    aptsRequestStatus: state.screens.scheduler.aptsRequestStatus,
    aptsRequestUpdateStatus: state.screens.employer.phaRequestStatus,
    aptsRequestError: state.screens.scheduler.aptsRequestError,
    aptsRequestUpdateError: state.screens.employer.phaRequestErrorMessage,
    eventTypeDefaults: getAssociatedEmployerUIConfig(state)?.eventTypeDefaults,
    schedules: state.screens.scheduler.scheduleData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        acceptOrRejectEmployerApptRequest,
        submitPHARequest,
        resetStatus,
        resetState,
        resetEmployerStatus,
        setAppointmentDetails,
      },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AppointmentRequestFormScreenLoggedIn);
